<script lang="ts">import { goto } from "$app/navigation";
import { page } from "$app/stores";
import ReferralIconAnimated from "../icons/referral.svelte";
import { jackpotMEGA, menuAutoCollapsed, menuMobileOpen, startMegajackpotPolling } from "../state";
import { GameCategory } from "@infinitro/catalog-min";
import { cfgToThemeCdnPath, formatBaseCurrency, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isBetbyDisplayed, isMobile, loggedIn, ModalDialog, parseUtcTimestamp, pushModal, stateBetbyPage, stateRaces, stateShowSidebarMobile, toCamelCase, toSiteUrl, toSiteUrlWithActive } from "@infinitro/global";
import { LocalIcon, RemoteIcon, TelegramIcon, TransparencyIcon } from "@infinitro/icons";
import { onDestroy, onMount } from "svelte";
let { category, isSearchModal = false, selectSection = () => null, paddingLeft = null, paddingRight = null, activeSection = "", isMenuCollapsed = $bindable(false), itemIdPrefix = "", activeFullWidth = false } = $props();
let hover = $state(false);
let isScrolling = false;
let showPrize = $state(true);
let countdown = $state("");
let toggleInterval = null;
let countdownInterval = null;
let stopMegajackpotPolling;
let isTransitioning = $state(false);
let isInitialized = $state(false);
let isSportsCategory = $derived(category.href.startsWith("/sports"));
let isFlushRaces = $derived(category.id === "flush-races");
function getActiveRace() {
	if (!$stateRaces || $stateRaces.length === 0) return null;
	const now = Date.now();
	return $stateRaces.find((race) => {
		const start = parseUtcTimestamp(race.startDate);
		const end = parseUtcTimestamp(race.endDate);
		return now >= start && now <= end;
	});
}
function calculateCountdown() {
	const activeRace = getActiveRace();
	if (!activeRace) {
		countdown = "";
		return;
	}
	const endTime = parseUtcTimestamp(activeRace.endDate);
	const now = Date.now();
	const diffMs = endTime - now;
	if (diffMs <= 0) {
		countdown = "";
		return;
	}
	const totalSeconds = Math.floor(diffMs / 1e3);
	const days = Math.floor(totalSeconds / 86400);
	const remDay = totalSeconds % 86400;
	const hours = Math.floor(remDay / 3600);
	const remHour = remDay % 3600;
	const minutes = Math.floor(remHour / 60);
	const seconds = remHour % 60;
	const dd = days > 0 ? `${days}d ` : "";
	const hh = String(hours).padStart(2, "0");
	const mm = String(minutes).padStart(2, "0");
	const ss = String(seconds).padStart(2, "0");
	countdown = `${dd}${hh}:${mm}:${ss}`;
}
let activeRace = $derived(getActiveRace());
let prizePoolText = $derived(activeRace ? formatBaseCurrency(activeRace.prizePool, true) : "");
const handleTouchMove = () => {
	isScrolling = true;
	if ($stateShowSidebarMobile === true) {
		document.body.classList.add("is-scrolling");
	}
};
const handleTouchEnd = () => {
	setTimeout(() => {
		isScrolling = false;
		if ($stateShowSidebarMobile === true) {
			document.body.classList.remove("is-scrolling");
		}
	}, 100);
};
const link_over = () => {
	if (!isScrolling && !useAlternative4) {
		hover = true;
	}
};
const link_out = () => {
	hover = false;
};
const click = (event) => {
	if (isScrolling) return;
	if (!$loggedIn && category.authed) {
		event.preventDefault();
		pushModal(ModalDialog.Auth, { tab: "signup" });
		return;
	}
	if (category.action) {
		event.preventDefault();
		category.action();
		return;
	}
	if (isSportsCategory) {
		event.preventDefault();
		const relPath = category.href.substring(7);
		const href = toSiteUrl(category.href, $loggedIn);
		if ($isBetbyDisplayed) {
			window.history.pushState({}, "", href);
			stateBetbyPage.set(relPath);
		} else {
			// eslint-disable-next-line svelte/no-navigation-without-resolve -- dynamic site URL from toSiteUrl
			goto(href);
		}
		if ($isMobile) {
			menuMobileOpen.set(false);
		}
	} else {
		// Optimistic instant highlight before the browser completes navigating to `href`.
		clickActive = true;
		if ($isMobile) {
			menuMobileOpen.set(false);
		}
	}
};
menuAutoCollapsed.subscribe((value) => {
	isMenuCollapsed = value;
});
let routeInfo = $derived.by(() => {
	if (isSearchModal) return {
		href: "",
		active: false
	};
	if (category.external) {
		return {
			href: category.href,
			active: false
		};
	}
	let [nextHref, nextActive] = toSiteUrlWithActive(category.href, `${$page.url.pathname}${$page.url.hash}`, $loggedIn);
	if (category.id === "promotions" && $page.url.pathname.includes("promotion-page") && !$page.url.pathname.includes("flush-races") && !$page.url.pathname.includes("/jackpot")) {
		nextActive = true;
	}
	return {
		href: nextHref,
		active: nextActive
	};
});
let href = $derived(routeInfo.href);
let linkRel = $derived(category.external ? category.target === "_blank" ? "external noopener noreferrer" : "external" : undefined);
// Clears the click-time optimistic override once the route actually changes.
let clickActive = $state(false);
$effect(() => {
	void routeInfo;
	clickActive = false;
});
let isSelected = $derived(isSearchModal && activeSection === category.href);
let isActive = $derived(isSearchModal ? isSelected : clickActive || routeInfo.active);
let useAlternative = $derived($stateUi.sidebar.sidebarStyle === "alternative");
let useAlternative2 = $derived($stateUi.sidebar.sidebarStyle === "alternative2");
let useAlternative4 = $derived($stateUi.sidebar.sidebarStyle === "alternative4");
let useRemoteIcons = $derived($stateUi.sidebar.useRemoteIcons ?? false);
let showJackpotMEGA = $derived($stateUi.sidebar?.showJackpotMEGA ?? false);
let useFlatNeutral = $derived($stateUi.sidebar?.useFlatNeutralSurface ?? false);
let flushRacesBg = $derived((() => {
	if (!isFlushRaces) return null;
	if ($isMobile) return cfgToThemeCdnPath("/sidebar/races-bg-mobile.png");
	return isMenuCollapsed ? cfgToThemeCdnPath("/sidebar/races-bg-collapsed.png") : cfgToThemeCdnPath("/sidebar/races-bg.png");
})());
onMount(() => {
	if (category.name === Verbiage.FOMO_jackpot || category.id === "jackpot" && showJackpotMEGA) {
		stopMegajackpotPolling = startMegajackpotPolling();
	}
	if ($isMobile) {
		window.addEventListener("touchmove", handleTouchMove);
		window.addEventListener("touchend", handleTouchEnd);
	} else {
		const element = document.getElementById(itemDomId);
		if (element) {
			element.addEventListener("mouseenter", link_over);
			element.addEventListener("mouseleave", link_out);
		}
	}
	if (isFlushRaces) {
		calculateCountdown();
		setTimeout(() => {
			isInitialized = true;
		}, 50);
		countdownInterval = setInterval(calculateCountdown, 1e3);
		toggleInterval = setInterval(() => {
			isTransitioning = true;
			setTimeout(() => {
				showPrize = !showPrize;
				setTimeout(() => {
					isTransitioning = false;
				}, 50);
			}, 300);
		}, 1e4);
	}
});
onDestroy(() => {
	if ($isMobile) {
		window.removeEventListener("touchmove", handleTouchMove);
		window.removeEventListener("touchend", handleTouchEnd);
	}
	if (toggleInterval) clearInterval(toggleInterval);
	if (countdownInterval) clearInterval(countdownInterval);
	stopMegajackpotPolling?.();
});
const NO_REPLACE = new Set(["VipIcon"]);
let itemDomId = $derived(itemIdPrefix ? `${itemIdPrefix}-${toCamelCase(category.name)}` : toCamelCase(category.name));
</script>

<div
	class="container container-search {isMenuCollapsed && !isSearchModal
		? 'container-collapsed'
		: ''}"
	class:sidebar-featured-race-row={isFlushRaces}
	class:active={isActive}
	class:active-alternative={isActive && (useAlternative || useAlternative4)}
	class:active-alternative-2={isActive && useAlternative2}
	class:active-alternative-4={isActive && useAlternative4 && !activeFullWidth}
	class:active-alternative-4-full={isActive && useAlternative4 && activeFullWidth}
	class:active-collapsed={isActive && isMenuCollapsed && !isSearchModal}
	style="padding-left: {paddingLeft} ; padding-right: {paddingRight}"
>
	{#if isSearchModal}
		<!-- svelte-ignore a11y_click_events_have_key_events -->
		<!-- svelte-ignore a11y_no_static_element_interactions -->
		<div
			id={itemDomId}
			class="item item-search {isActive ? 'active' : ''} {hover ? 'hover' : ''} {category.disabled
				? 'disabled'
				: ''}"
			class:alternative-search-item={useAlternative || useAlternative4}
			onclick={category.disabled ? null : () => selectSection(category.href)}
		>
			<span
				class="icon"
				class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
				class:is-active={isActive}
			>
				{#if category.id === 'telegram-follow'}
					<TelegramIcon />
				{:else if category.id === 'transparency'}
					<TransparencyIcon size={category?.iconSize ?? 20} bind:hover active={isActive} />
				{:else}
					<RemoteIcon
						icon={category.icon ?? ''}
						size={category?.iconSize ?? 20}
						bind:hover
						active={isActive}
						replaceFill={!NO_REPLACE.has(category.icon ?? '') &&
							$stateUi.layout.useCurrentColorSidebar}
						activeColor={useAlternative4 ? 'var(--color-accent-100)' : 'var(--color-primary-500)'}
					/>
				{/if}
			</span>
			<span
				class="text text-search {isActive || hover ? 'active' : ''} {category.disabled
					? 'disabled'
					: ''}">{$t(category.name)}</span
			>
		</div>
	{:else}
		<!-- eslint-disable svelte/no-navigation-without-resolve -- dynamic site URL from toSiteUrl -->
		<a
			id={itemDomId}
			{href}
			target={category.target}
			rel={linkRel}
			class:item-link-alternative={useAlternative || useAlternative4}
			class:item-link-alternative-4={useAlternative4}
			class="item-link {category.disabled ? 'disabled' : ''} {hover ? 'hover' : ''}"
			class:sidebar-featured-race-link={isFlushRaces}
			class:sidebar-featured-race-link-flat-neutral={isFlushRaces && useFlatNeutral}
			style={isFlushRaces && flushRacesBg ? `background-image: url(${flushRacesBg})` : ''}
			onpointerenter={!$isMobile ? link_over : null}
			onpointerleave={!$isMobile ? link_out : null}
			onclick={click}
			aria-disabled={category.disabled}
		>
			<div
				class="item {category.disabled ? 'disabled' : ''}"
				class:hover={hover && !useAlternative4}
				class:active={isActive && !useAlternative4}
				class:alternative-item={useAlternative || useAlternative4}
				class:sidebar-featured-race-inner={isFlushRaces}
			>
				<span
					class="icon"
					class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
					class:is-active={isActive}
				>
					{#if category.id === 'telegram-follow'}
						<TelegramIcon />
					{:else if useRemoteIcons}
						<RemoteIcon
							icon={category.icon ?? ''}
							size={category?.iconSize ?? 20}
							bind:hover
							active={isActive && !useAlternative4}
							replaceFill={!NO_REPLACE.has(category.icon ?? '') &&
								$stateUi.layout.useCurrentColorSidebar}
						/>
					{:else if useAlternative4 && !isSportsCategory}
						<LocalIcon size={category?.iconSize ?? 20} icon={category.icon} />
					{:else if category.id === 'referral' && $stateUi.layout.useReferralIconAnimated}
						<ReferralIconAnimated size={category?.iconSize ?? 20} bind:hover active={isActive} />
					{:else if category.id === 'transparency'}
						<TransparencyIcon size={category?.iconSize ?? 20} bind:hover active={isActive} />
					{:else}
						<RemoteIcon
							icon={category.icon ?? ''}
							size={category?.iconSize ?? 20}
							bind:hover
							active={isActive && !useAlternative4}
							replaceFill={!NO_REPLACE.has(category.icon ?? '') &&
								$stateUi.layout.useCurrentColorSidebar}
						/>
					{/if}
				</span>
				<span
					class="text {category.disabled ? 'disabled' : ''}"
					class:active={(isActive || hover) && !useAlternative4}
					class:not-auto-fill={!$stateUi.layout.useCurrentColorSidebar}
					class:sidebar-featured-race-meta={isFlushRaces && prizePoolText && countdown}
					class:text-hidden={isMenuCollapsed && !isSearchModal}
				>
					{$t(category.name)}
					{#if isFlushRaces && prizePoolText && countdown}
						<span class="highlight-container">
							<span
								class="highlight-text"
								class:visible={showPrize && isInitialized && !isTransitioning}
								class:slide-out={isTransitioning && showPrize}
								class:hidden-above={!showPrize}
							>
								{prizePoolText}
							</span>
							<span
								class="highlight-text"
								class:visible={!showPrize && isInitialized && !isTransitioning}
								class:slide-out={isTransitioning && !showPrize}
								class:hidden-above={showPrize}
							>
								{countdown}
							</span>
						</span>
					{/if}
				</span>
				{#if category.name === Verbiage.FOMO_jackpot}
					<span
						class="badge"
						class:badge-alternative={useAlternative || useAlternative4}
						class:text-hidden={isMenuCollapsed && !isSearchModal}
					>
						{jackpotMEGA.value}
					</span>
				{/if}
				{#if category.id === 'jackpot' && showJackpotMEGA}
					<span
						class="badge"
						class:badge-alternative4={useAlternative4}
						class:text-hidden={isMenuCollapsed && !isSearchModal}>{jackpotMEGA.value}</span
					>
				{/if}
			</div>
			{#if isFlushRaces && !isMenuCollapsed}
				<img
					src={cfgToThemeCdnPath('/sidebar/races-bg-illustration.png')}
					alt={$t(Verbiage.races_banner_alt)}
					class="races-illustration"
				/>
			{/if}
		</a>
		<!-- eslint-enable svelte/no-navigation-without-resolve -->
	{/if}
</div>

<style>
	.badge {
		border-radius: 0.75rem;
		background-color: var(--color-primary-500);
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		padding-top: 1px;
		padding-bottom: 1px;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		font-size: 0.75rem;
		line-height: 1rem;
}
	@media (min-width: 1024px) {
		.badge {
				font-size: 10px;
		}
}
	.badge {
		overflow: hidden;
		max-width: 100px;
		transition:
			opacity 0.15s ease,
			max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.badge.text-hidden {
		opacity: 0;
		max-width: 0;
		pointer-events: none;
	}

	.badge-alternative {
		color: var(--color-text-100);
}

	.badge-alternative4 {
		background-color: var(--color-accent-500);
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

	.container {
		position: relative;
		display: flex;
		align-items: center;
		font-weight: 400;
}

	.container-collapsed {
		width: 100%;
}

	.container-search {
		margin-top: -2px;
		margin-bottom: -2px;
		width: 100%;
}

	.sidebar-featured-race-row {
		padding: 0 !important;
		height: 42px !important;
	}

	.container.active::before {
		content: '';
		position: absolute;
		left: -15px;
		height: 100%;
		width: 5px;
		border-top-right-radius: 0.5rem;
		border-bottom-right-radius: 0.5rem;
		background: var(--gradient-primary);
		box-shadow: 0 0 3px 3px color-mix(in srgb, var(--color-primary-100) 20%, transparent);
	}

	.container.active-alternative::before {
		background-color: var(--color-primary-500);
		box-shadow: unset;
		background-image: unset;
}

	.container.active-alternative-2::before {
		background: linear-gradient(180deg, var(--color-primary-500) 0%, var(--color-primary-700) 100%);
	}

	.container.active-alternative-4::before {
		left: 0;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 12px;
		box-shadow: unset;
		background-image: unset;
		width: 100%;
	}

	.container.active-alternative-4.active-collapsed::before {
		left: 0;
		right: 0;
		width: auto;
	}

	.container.active-alternative-4-full::before {
		background-color: var(--component-side-bar-dropdown-side-bar-item-bg);
		border-radius: 0;
		box-shadow: unset;
		background-image: unset;
		left: -15px;
		right: -30px;
		width: unset;
		z-index: -1;
	}

	.container.active-collapsed:not(.active-alternative-4):not(.active-alternative-4-full)::before {
		/* @apply left-[-28px]; */
	}

	a.item-link {
		display: flex;
		width: 100%;
		border-radius: 14px;
		font-size: 14px;
		font-family: var(--font-main);

		&.disabled {
				pointer-events: none;
		}

		&.disabled {
				cursor: not-allowed;
		}

		&.disabled {
				opacity: 0.5;
		}

		&:global(.hover),
		&:hover {
				color: var(--color-text-100);
		}
}

	a.sidebar-featured-race-link {
		position: relative;
		height: 100%;
		width: 100%;
		overflow: hidden;
		border-radius: 10px;
		background-size: cover;
		background-repeat: no-repeat;
		padding-left: 12px;
		border: 1px solid var(--color-primary-100);
}

	a.sidebar-featured-race-link.sidebar-featured-race-link-flat-neutral {
		border: none;
	}

	a.sidebar-featured-race-link .item {
		height: 100%;
		color: var(--color-text-100) !important;
		opacity: 90%;
		&.active,
		&:global(.hover),
		&:hover {
			opacity: 100%;
		}
}

	.races-illustration {
		position: absolute;
		right: 0px;
		height: 100%;
}

	a.item-link-alternative {
		&:global(.hover),
		&:hover {
				color: var(--color-primary-500);
		}

		& span.text.active {
				color: var(--color-primary-500);
		}

		& > .item.active,
		& > .item:global(.hover),
		& > .item:hover {
				color: var(--color-primary-500);
		}
	}

	a.item-link-alternative-4 {
		&:global(.hover),
		&:hover {
				color: unset;
		}

		& span.text.active {
				color: unset;
		}

		& > .item.active,
		& > .item:global(.hover),
		& > .item:hover {
				color: unset;
		}
	}

	div.item {
		display: flex;
		cursor: pointer;
		flex-wrap: nowrap;
		align-items: center;
		gap: 0.25rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		color: var(--color-text-300);

		&.disabled {
				cursor: not-allowed;
		}

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		}

		&:global(.hover),
		&:hover {
				color: var(--color-text-100);
		}

		&.active {
				color: var(--color-text-100);
		}
}

	div.alternative-item {
		color: var(--color-text-100);
}

	div.alternative-search-item {
		opacity: 0.5;
}

	span.icon {
		display: flex;
		min-height: 20px;
		min-width: 20px;
		align-items: center;
		justify-content: center;
		padding-bottom: 2px;
}

	span.text {
		margin-left: 0.25rem;
		height: 20px;
		flex: 1 1 0%;
		white-space: nowrap;
		font-size: 14px;
		overflow: hidden;
		max-width: 200px;
		transition:
			opacity 0.15s ease,
			max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
			margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1);

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity, 1));
		}

		&:global(.hover),
		&:hover {
				color: var(--color-text-100);
		}

		&.active {
				color: var(--color-text-100);
		}
}

	span.text.text-hidden {
		opacity: 0;
		max-width: 0;
		margin-left: 0;
		pointer-events: none;
	}

	span.text-search {
		font-size: 12px;
		text-transform: uppercase;
		font-family: var(--font-main);
}

	div.item-search {
		display: flex;
		align-items: center;
		border-radius: 14px;
		font-size: 12px;
		font-weight: 600;
		text-transform: uppercase;
		font-family: var(--font-main);

		&:global(.hover),
		&:hover {
				opacity: 1;
		}

		&.active {
				opacity: 1;
		}
}

	div.item-search:hover,
	div.item-search.active {
		opacity: 1;
}

	span.text.not-auto-fill {
		font-weight: 600;
	}

	span.icon.not-auto-fill {
		opacity: 0.7;
}

	a.sidebar-featured-race-link .item span.icon.not-auto-fill {
		opacity: 1;
}

	span.icon.not-auto-fill.is-active,
	.item:global(.hover) span.icon.not-auto-fill,
	.item-search:global(.hover) span.icon.not-auto-fill {
		opacity: 1;
}

	div.sidebar-featured-race-inner {
		position: relative;
		padding-top: 0px;
		padding-bottom: 0px;
}

	.sidebar-featured-race-meta {
		position: absolute;
		left: 24px;
		top: 2px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		height: auto !important;
		overflow: visible !important;
}

	.highlight-container {
		position: relative;
		height: 0.7rem !important;
		min-height: 0.7rem !important;
		width: 80px;
		display: block !important;
}

	.highlight-text {
		position: absolute;
		left: 0px;
		top: 0px;
		font-size: 0.7rem;
		color: var(--color-highlight-1);
		transition:
			transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
			opacity 0.6s ease;
		opacity: 0;
}

	.highlight-text.visible {
		opacity: 1 !important;
		transform: translateY(0) !important;
	}

	.highlight-text.slide-out {
		transform: translateY(100%);
		opacity: 0;
	}

	.highlight-text.hidden-above {
		transform: translateY(-100%);
		opacity: 0;
	}
</style>
